module.exports = __webpack_public_path__ + "img/5@2x.0e3a2aff.png";